module.exports = __webpack_public_path__ + "img/18.41bd7a59.svg";